import { observable } from '@legendapp/state';

import { VerticalBreakpoints } from '../../hooks/use-vertical-breakpoint';

import { PickerType } from '../../components/option-selector/picker';
import { DeviceOrientation, DeviceType, deviceSettingStore } from './device-setting-store';
import { fullscreenStore } from './fullscreen-store';

interface SliderStore {
	activePicker: PickerType;
	isDoubleSliderVisible: boolean;
}

export const sliderStore = observable<SliderStore>({
	activePicker: 'color' as PickerType,
	isDoubleSliderVisible: () => {
		const { isMobileDevice, deviceType, deviceOrientation, screenHeight } = deviceSettingStore.get();
		const isLandscapeOrientation = deviceOrientation === DeviceOrientation.Landscape;
		const isIpad = deviceType === DeviceType.iPad;
		const isFullscreenMode = fullscreenStore.isFullscreenMode.get();
		const smallMobileHeightCondition = screenHeight < VerticalBreakpoints.b340;

		return ((isLandscapeOrientation && smallMobileHeightCondition) || isFullscreenMode) && isMobileDevice && !isIpad;
	}
});

export const sliderStoreActions = {
	setActivePicker: (picker: PickerType) => {
		sliderStore.activePicker.set(picker);
	}
};
